import React, { useEffect, useState } from 'react';
import { VRButton } from 'three/examples/jsm/webxr/VRButton.js';
import * as THREE from "three";
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';
import TWEEN from '@tweenjs/tween.js';

const VrButton = ({ rendererr, cameraz, spawnmodelz, spawnedModels, scenez }) => {
  const [isVRMode, setIsVRMode] = useState(false);
  let controller;
  let controls;

  useEffect(() => {
    if (rendererr) {
      const vrButton = document.body.appendChild(VRButton.createButton(rendererr));
      vrButton.style.width = '400px';
      vrButton.style.height = '50px';
      vrButton.addEventListener('click', () => {
        // Scale the spawnmodelz only after entering VR mode
        scenez.scale.set(0.1, 0.1, 0.1);
        // spawnedModels.scale.set(0.1, 0.1, 0.1);
        setIsVRMode(true);
      });
      document.body.appendChild(vrButton);

      // Event listener for exiting VR mode
      window.addEventListener('vrdisplaydeactivate', () => {
        setIsVRMode(false);
      });

      return () => {
        document.body.removeChild(vrButton);
        window.removeEventListener('vrdisplaydeactivate', () => {
          setIsVRMode(false);
        });
      };
    }
  }, [rendererr, scenez]);

  useEffect(() => {
    if (scenez && rendererr && isVRMode) {
      const buttonGroup = new THREE.Group();
      const buttonMaterial = new THREE.MeshBasicMaterial({ color: 0xff0000 }); // Red color for buttons

      // Create Button 1
      const button1Geometry = new THREE.BoxGeometry(1, 1, 1);
      const button1Mesh = new THREE.Mesh(button1Geometry, buttonMaterial);
      button1Mesh.position.set(-2, 0, -5); // Adjust position as needed
      button1Mesh.name = "Button1";
      buttonGroup.add(button1Mesh);

      // Create Button 2
      const button2Geometry = new THREE.BoxGeometry(1, 1, 1);
      const button2Mesh = new THREE.Mesh(button2Geometry, buttonMaterial);
      button2Mesh.position.set(0, 0, -5); // Adjust position as needed
      button2Mesh.name = "Button2";
      buttonGroup.add(button2Mesh);

      // Create Button 3
      const button3Geometry = new THREE.BoxGeometry(1, 1, 1);
      const button3Mesh = new THREE.Mesh(button3Geometry, buttonMaterial);
      button3Mesh.position.set(2, 0, -5); // Adjust position as needed
      button3Mesh.name = "Button3";
      buttonGroup.add(button3Mesh);

      scenez.add(buttonGroup);

      // Initialize XR controllers
      const initXRControllers = () => {
        const controllerModelFactory = new XRControllerModelFactory();

        const controllerGrip1 = rendererr.xr.getControllerGrip(0);
      
        controllerGrip1.add(controllerModelFactory.createControllerModel(controllerGrip1));
        scenez.add(controllerGrip1);

        controller = rendererr.xr.getController(0);
        controller.addEventListener('connected', onControllerConnected);
        scenez.add(controller);
      };

      const onControllerConnected = () => {
        // Controller connected event handling if needed
      };

      // Call the function to initialize XR controllers
      initXRControllers();

      const onSelectStart = (event) => {
        const controller = event.target;
        const intersections = getIntersections(controller);
        if (intersections.length > 0) {
          const clickedObject = intersections[0].object;
          switch (clickedObject.name) {
            case "Button1":
              alert("You clicked Button 1");
              break;
            case "Button2":
              alert("You clicked Button 2");
              break;
            case "Button3":
              alert("You clicked Button 3");
              break;
            default:
              break;
          }
        }
      };

      const getIntersections = (controller) => {
        const tempMatrix = new THREE.Matrix4();
        tempMatrix.identity().extractRotation(controller.matrixWorld);
        const raycaster = new THREE.Raycaster();
        raycaster.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        raycaster.ray.direction.set(0, 0, -1).applyMatrix4(tempMatrix);
        return raycaster.intersectObjects(buttonGroup.children);
      };

      if (navigator.xr) {
        navigator.xr.addEventListener('selectstart', onSelectStart);
      }

      return () => {
        scenez.remove(buttonGroup);
        if (controller) {
          controller.removeEventListener('connected', onControllerConnected);
          scenez.remove(controller);
        }
        if (navigator.xr) {
          navigator.xr.removeEventListener('selectstart', onSelectStart);
        }
      };
    }
  }, [rendererr, scenez, isVRMode]);

  return null;
};

export default VrButton;
